import { useEffect, useState } from 'react';
import { SectionWrapper } from '../../../../components/ui/SectionWrapper';
import { TechBadge } from '../../../../components/ui/TechBadge';
import { useLanguage } from '../../../../context/LanguageContext';
import { Skill } from '../../../../models/skill.interface';
import { skillsService } from '../../../../services/skills.service';

export function SkillsSection() {
    const { lang, t } = useLanguage();
    const [skills, setSkills] = useState<Skill[]>([]);

    useEffect(() => {
        setSkills(skillsService.fetchSkills());
    }, []);

    return (
        <SectionWrapper id="skills" title={t('section.skills')}>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {skills.map(skill => (
                    <div key={skill.id} className="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm ring-1 ring-slate-900/5 dark:ring-slate-700/50">
                        <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-4">
                            {skill.name[lang]}
                        </h3>
                        <div className="flex flex-wrap gap-2">
                            {skill.technologies.map(tech => (
                                <TechBadge key={tech.id} name={tech.name} />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </SectionWrapper>
    );
}
